module.exports = __webpack_public_path__ + "static/media/message-fake-image.f1905eaa.jpg";